module.exports = __webpack_public_path__ + "static/event-hub-content-48e54d5a9f7f0b9b41d89d838d389e0f.png";